module.exports = __webpack_public_path__ + "static/video-nfts-background-8716aae1eb35e4413daeaaac0d531be3.webp";